module.exports = __webpack_public_path__ + "static/img/bf-base.cdaefd13.png";